import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useToast,
  Heading,
  Center,
  Image,
} from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [isChanged, setIsChanged] = useState(false);

  // 2. 비밀번호 변경 전에는 새로고침/이동/뒤로가기 등 페이지 이탈을 막음
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isChanged) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isChanged]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 비밀번호 확인
      if (password !== confirmPassword) {
        throw new Error("비밀번호가 일치하지 않습니다.");
      }

      // 비밀번호 길이 확인
      if (password.length < 6) {
        throw new Error("비밀번호는 6자 이상이어야 합니다.");
      }

      // 비밀번호 형식 확인 (소문자, 숫자, 특수기호 각각 1개 이상)
      if (
        !/(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\]\\/~`';_+=-]).+/.test(
          password
        )
      ) {
        throw new Error(
          "비밀번호는 소문자, 숫자, 특수기호를 각각 1개 이상 포함해야 합니다."
        );
      }

      // 기본 비밀번호 확인
      if (password === "!@rhoonart") {
        throw new Error("기본 비밀번호는 사용할 수 없습니다.");
      }

      // Supabase를 통해 비밀번호 재설정
      const { error } = await supabase.auth.updateUser({
        password: password,
      });

      if (error) {
        throw error;
      }

      toast({
        title: "비밀번호가 성공적으로 변경되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });

      setIsChanged(true); // 비밀번호 변경 성공 시 이탈 허용
      // 로그인 페이지로 이동
      navigate("/login");
    } catch (error) {
      toast({
        title: "비밀번호 변경 실패",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="container.sm" py={10} position="relative" minH="100vh">
      {/* 홈으로 가기 버튼 - 오른쪽 상단 고정 */}
      <Button
        colorScheme="gray"
        variant="ghost"
        size="md"
        onClick={() => navigate("/")}
        position="absolute"
        top="24px"
        right="32px"
        borderRadius="full"
        boxShadow="sm"
        fontWeight="bold"
        _hover={{ bg: "gray.200" }}
        zIndex={10}
      >
        홈으로 가기
      </Button>
      {/* 플플 로고 중앙 정렬, 크게 */}
      <Center flexDirection="column" mb={8} mt={12}>
        <Image src="/images/plpl.png" alt="플플 로고" boxSize="220px" mb={4} />
      </Center>
      <Box bg="white" p={10} borderRadius="2xl" boxShadow="2xl" mt={4}>
        <Stack spacing={6}>
          <Heading size="lg" textAlign="center">
            비밀번호 재설정
          </Heading>
          <Text textAlign="center" color="gray.600">
            새로운 비밀번호를 입력해주세요.
          </Text>
          <form onSubmit={handleResetPassword}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>새 비밀번호</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="비밀번호는 영어, 숫자, 특수기호를 1개씩 포함하여 6자 이상 입력해주세요."
                  size="lg"
                  borderRadius="xl"
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>비밀번호 확인</FormLabel>
                <Input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="비밀번호를 다시 입력하세요"
                  size="lg"
                  borderRadius="xl"
                />
              </FormControl>
              <Button
                type="submit"
                colorScheme="blue"
                isLoading={loading}
                w="100%"
                size="lg"
                borderRadius="xl"
                fontWeight="bold"
              >
                비밀번호 변경
              </Button>
            </Stack>
          </form>
        </Stack>
      </Box>
    </Container>
  );
};

export default ResetPassword;
